<template>
  <div class="woAppHouseholdManageList">
    <div class="filters">
      <el-form :inline="true">
        <!-- 选择日期 
        <el-form-item :label="$t('lang.lab_RegTime')">
          <el-date-picker
            v-model="datevalues"
            type="daterange"
            :range-separator="$t('lang.lab_to')"
            :start-placeholder="$t('lang.lab_startDate')"
            :end-placeholder="$t('lang.lab_endDate')"
            value-format="timestamp"
          ></el-date-picker>
        </el-form-item>-->
        <!-- 选择楼号 -->
        <el-form-item>
          <el-select v-model="floorid" @change="selectUnit">
            <el-option key :label="$t('lang.lab_floorName')" value=''></el-option>
            <el-option v-for="(item,index) in floorList" :key="index" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <!-- 选择单元号 -->
        <el-form-item>
          <el-select v-model="unitid" @change="selectRoom">
            <el-option key :label="$t('lang.lab_unitName')" value=''></el-option>
            <el-option v-for="(item,index) in unitList" :key="index" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <!-- 选择房间号 -->
        <el-form-item>
          <el-select v-model="roomid">
            <el-option key :label="$t('lang.lab_roomName')" value=''></el-option>
            <el-option v-for="(item,index) in roomList" :key="index" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <!-- 身份 -->
        <el-form-item>
          <el-select class="select" v-model="user" :placeholder="$t('lang.APPHOUSEHOLDMANAGE.USERTYPE[0].label')">
            <el-option v-for="item in Identitys" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <!-- 标签 -->
        <!-- <el-form-item>
          <el-select
            class="select"
            v-model="tag"
            :placeholder="$t('lang.APPHOUSEHOLDMANAGE.TAGS[0].label')">
              <el-option
              v-for="item in tags"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              ></el-option>
          </el-select>
        </el-form-item> -->
        <!-- 关键字 -->
        <el-form-item>
          <el-input class="seachInput" v-model="keyword" placeholder="请输入用户名或手机号"></el-input>
        </el-form-item>
        <el-button type="primary" @click="submit()">{{$t('lang.btn_search')}}</el-button>
      </el-form>
    </div>
    <el-card>
      <el-table :data="tableData" class="wid100"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight655 : require('@/config/enum').tableheight109"
        :row-class-name="tableRowClassName" @selection-change="handleSelectionChange">
        <!-- checkbox -->
        <el-table-column type="selection" width="55" v-if="appHouseholdManageListcheckbox"></el-table-column>
        <!-- 序号 -->
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px">
        </el-table-column>
        <!-- 用户名 -->
        <el-table-column prop="nickName" :label="$t('lang.lab_username')"></el-table-column>
        <!-- 手机 -->
        <el-table-column prop="mobile" :label="$t('lang.lab_phone')"></el-table-column>
        <!-- 小区 -->
        <el-table-column prop="garden.name" :label="$t('lang.lab_village')"></el-table-column>
        <!-- 楼号 -->
        <el-table-column prop="garden.grids.houseName" :label="$t('lang.lab_buildingnum')"></el-table-column>
        <!-- 单元号 -->
        <el-table-column prop="garden.grids.unitName" :label="$t('lang.lab_unitnum')"></el-table-column>
        <!-- 房间号 -->
        <el-table-column prop="garden.grids.roomName" :label="$t('lang.lab_roomnum')"></el-table-column>
        <!-- 身份 -->
        <!-- <el-table-column prop="garden.userType" :label="$t('lang.lab_identitynum')">
          <template slot-scope="scope">
            <span
              v-if="scope.row.garden.userType === 1"
            >{{$t('lang.APPHOUSEHOLDMANAGE.USERTYPE[1].label')}}</span>
            <span
              v-if="scope.row.garden.userType === 2"
            >{{$t('lang.APPHOUSEHOLDMANAGE.USERTYPE[2].label')}}</span>
            <span
              v-if="scope.row.garden.userType === 3"
            >{{$t('lang.APPHOUSEHOLDMANAGE.USERTYPE[3].label')}}</span>
          </template>
        </el-table-column>   -->
        <!-- 人员名称 -->
        <el-table-column prop="waName" :label="$t('lang.lab_userName1')"></el-table-column>
        <!-- 人像图片 -->
        <!-- <el-table-column label="人像图片">
          <template slot-scope="scope" v-if="scope.row.url">
            <el-image style="width: 100px; height: auto" :src="scope.row.url" :preview-src-list="scope.row.srcList">
            </el-image>
          </template>
        </el-table-column> -->
        <el-table-column prop="srcList" label="人像图片" width="300px">
          <template slot-scope="scope" v-if="scope.row.url">
            <viewer :images="scope.row.srcList" class="img-width">
              <img class="img" v-for="(src,index) in scope.row.srcList" :src="src" :key="index">
            </viewer>
          </template>
        </el-table-column>
        <!-- 人像所有者（识别主体）guid -->
        <el-table-column prop="admitGuid" :label="$t('lang.lab_admitGuid')"></el-table-column>
        <!-- 操作 -->
        <el-table-column prop="operation" :label="$t('lang.lab_operation')" fixed="right"
          :width="require('@/config/enum').opr_width4">
          <template slot-scope="scope">
            <el-button @click="change(scope.row)" v-if="scope.row.waId == null">{{$t('lang.btn_addWoAdmit')}}
            </el-button>
            <el-button class="orange" @click="del(scope.row)" v-if="scope.row.waId != null">
              {{$t('lang.btn_delWoAdmit')}}</el-button>
            <el-button @click="showCamera(scope.row)" v-if="scope.row.admitGuid != null&&scope.row.woFaces.length<3">
              人像注册
            </el-button>
            <el-button class="orange" @click="showDelImg(scope.row)" v-if="scope.row.url">人像删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 添加页码 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
    <el-dialog :title=title :visible.sync="isPopupPage" :close-on-click-modal="false" center top="130px" width="600px"
      @closed="handleDialogClosed">
      <el-form :model="diaForm" :rules="rules" ref="diaForm" :label-width="require('@/config/enum').c_ws8"
        :label-suffix="require('@/config/enum').c_colon">
        <el-form-item :label="$t('lang.lab_userName1')" prop="name">
          <el-input :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_userName1')" v-model="diaForm.name">
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_waPhone')" prop="phone">
          <el-input :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_waPhone')" v-model="diaForm.phone">
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.resourRemark')" prop="tag">
          <el-input :placeholder="$t('lang.lab_please_Input')+$t('lang.resourRemark')" v-model="diaForm.tag"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="clear('diaForm')">{{$t('lang.btn_rest')}}</el-button>
        <el-button type="primary" @click="save('diaForm')">{{$t('lang.btn_save')}}</el-button>
      </div>
    </el-dialog>
    <!-- 摄像头start -->
    <el-dialog class="cameraDlg" title="人像注册" :visible.sync="isShowCamera" :close-on-click-modal="false" center
      top="130px" width="800px" @closed="handleDialogClosed1">
      <!-- <el-image class="cameraImg" v-show="!openCamera" @click="getCompetence"
        src="http://zhwyjk.kmyhwy.cn/wxcode/wo/xj.png" fit="contain"></el-image> -->
      <div class="camera_outer" v-show="openCamera">
        <video v-show="openCamera&&!imgSrc" id="videoCamera" width="100%" height="100%" autoplay></video>
        <canvas style="display: none" id="canvasCamera" :width="videoWidth" :height="videoHeight"></canvas>
        <div v-if="imgSrc" class="img_bg_camera">
          <p class="previewTitle">效果预览</p>
          <img :src="imgSrc" alt class="tx_img" width="100%" />
        </div>
        <div class="CameraBtn">
          <el-button type="primary" v-if="!imgSrc" @click="setImage()">拍照</el-button>
          <el-button type="primary" v-if="imgSrc" @click="resetCamera">重拍</el-button>
          <el-button type="success" :disabled="imgSrc==''" @click="saveCamera">保存</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 摄像头end -->
    <!-- 人像删除弹窗start -->
    <el-dialog class="cameraDlg" title="人像删除" :visible.sync="isShowDelImg" :close-on-click-modal="false" center
      top="130px" width="800px" @closed="handleDialogClosed2">
      <div class="peopleImgBox" v-for="(item,index) in peopleData.woFaces" :key="index">
        <el-checkbox class="peoCheckBox" @change="selectDelImg($event,item)">
          <el-image class="peopleImg" :src="item.url" fit="contain"></el-image>
        </el-checkbox>
      </div>

      <div class="CameraBtn">
        <el-button type="success" :disabled="!delPeoImgArr.length>0" @click="delPeoImg()">删除</el-button>
      </div>
    </el-dialog>
    <!-- 人像删除弹窗end -->
  </div>
</template>

<script>
  /**
   *@ClassName:appHouseholdManage
   *@Description:app住户管理
   *@author:李斌
   *@Copyright:格众科技
   *@date:2020-03-16
   */
  import {
    mapGetters
  } from 'vuex'

  export default {
    name: '/manage/main.user',
    data() {
      return {
        // 摄像头start
        isShowCamera: false,
        isShowDelImg: false,
        videoWidth: 550,
        videoHeight: 350,
        imgSrc: '', // 本地拍照图片地址（base64）
        woFaceUrl: '', // 服务器拍照图片地址
        thisCancas: null,
        thisContext: null,
        thisVideo: null,
        openCamera: false,
        peopleData: '', // 人像信息
        delPeoImgArr: [], // 删除人像照片
        // 摄像头end
        multipleSelection: [], // 多选框
        datevalues: [], // 开始结束时间绑定值
        floorid: '', // 楼层绑定值
        floorList: [], // 楼层下拉列表
        unitid: '', // 单元绑定值
        unitList: [], // 单元下拉列表
        roomid: '', // 房间绑定值
        roomList: [], // 房间下拉列表
        user: '0', // 身份
        tag: '0', // 标签
        keyword: '', // 手机或序号内容input
        pageCount: 0, // 总页数
        pageNo: 1, // 第几页
        pageSize: 10, // 每页显示数
        tableData: [], // 列表数组
        type: 1, // 楼号单元号房间号区分
        parentId: '',
        title: '', // 弹框显示的标题
        isPopupPage: false, // 弹框的显示控制
        diaForm: {
          userId: '',
          name: '',
          phone: '',
          tag: ''
        },
        rules: {
          name: [{
            required: true,
            message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_userName1'),
            trigger: 'blur'
          }],
          phone: [{
            required: true,
            message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_waPhone'),
            trigger: 'blur'
          }]
        },
        Identitys: this.$i18n.t('lang.APPHOUSEHOLDMANAGE.USERTYPE'), // 身份列表
        tags: this.$i18n.t('lang.APPHOUSEHOLDMANAGE.TAGS'), // 标签列表
        appHouseholdManageListcheckbox: require('@/config/enum').appHouseholdManageListcheckbox, // 是否隐藏复选框
      }
    },
    created() {
      // 初始化
      this.topics()
      // 获取楼号
      this.gardenGrids(this.gardenId)
    },
    activated() {
      // 初始化
      this.topics()
      // 获取楼号
      this.gardenGrids(this.gardenId)
    },
    computed: {
      ...mapGetters(['gardenId'])
    },
    // 监听改变小区编号
    watch: {
      gardenId: function (newFlag, oldFlag) {
        this.gardenChange()
      }
    },
    methods: {
      clear(diaForm) {
        this.$refs[diaForm].resetFields()
        this.diaForm.userId = ''
        this.diaForm.name = ''
        this.diaForm.phone = ''
        this.diaForm.tag = ''
        setTimeout(() => {
          this.$refs[diaForm].clearValidate()
        }, 0)
      },
      save(diaForm) {
        this.$refs[diaForm].validate((valid) => {
          if (valid) {
            let params = {
              gardenId: this.gardenId,
              userId: this.diaForm.userId,
              name: this.diaForm.name,
              phone: this.diaForm.phone,
              tag: this.diaForm.tag
            }
            let loading = this.$loading()
            this.$post(`/woAdmit`, params).then(
              res => {
                loading.close()
                // if (res && res.errCode === 0) {
                this.$message.success(this.$i18n.t('lang.lab_save_success'))
                this.isPopupPage = false
                this.pageNo = 1
                this.topics()
                // }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          } else {
            return false
          }
        })
      },
      // ID序号功能
      indexMethod(index) {
        return (this.pageNo - 1) * this.pageSize + index + 1
      },
      // 列表斑马线
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // 添加多选框
      handleSelectionChange(val) {
        this.multipleSelection = val
      },
      // 监听关闭dialog
      handleDialogClosed() {
        this.$refs.diaForm.resetFields()
        this.diaForm.name = ''
        this.diaForm.phone = ''
        this.diaForm.tag = ''
      },
      // 改变小区
      gardenChange() {
        this.floorid = ''
        this.topics()
        this.unitid = ''
        this.roomid = ''
        this.unitList = ''
        this.roomList = ''
        this.type = 1
        this.gardenGrids(this.gardenId)
      },
      // 获取楼号单元号房间号
      gardenGrids(parentId) {
        let loading = this.$loading()
        this.$get(`/gardenGrids?type=${this.type}&parentId=${parentId}&pageNo=1&pageSize=999`).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              if (this.type === 1) {
                this.floorList = res.list
              } else if (this.type === 2) {
                this.unitList = res.list
                this.roomList = ''
                if (this.floorid === '') {
                  this.unitList = ''
                  this.roomList = ''
                }
              } else if (this.type === 3) {
                this.roomList = res.list
                if (this.unitid === '') {
                  this.roomList = ''
                }
              }
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      topics() {
        var startTs = ''
        var endTs = ''
        if (this.datevalues != null) {
          if (this.datevalues.length > 0) {
            startTs = this.datevalues[0]
            endTs = this.datevalues[1]
          }
        }
        let loading = this.$loading()
        this.$get(
          `/usersWo?pageNo=${this.pageNo}&pageSize=${this.pageSize}&gardenId=${this.gardenId}&houseId=${this.floorid}&unitId=${this.unitid}&roomId=${this.roomid}&userType=${this.user}&woKey=${this.keyword}&tagId=${this.tag}&startTs=${startTs}&endTs=${endTs}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              this.tableData = res.list
              for (let i = 0; i < this.tableData.length; i++) {
                this.tableData[i].srcList = []
                if (this.tableData[i].woFaces) {
                  if (this.tableData[i].woFaces.length > 0) {
                    this.tableData[i].url = this.tableData[i].woFaces[0].url
                    for (let j = 0; j < this.tableData[i].woFaces.length; j++) {
                      this.tableData[i].srcList.push(this.tableData[i].woFaces[j].url)
                    }
                  }
                }
              }
              console.log(this.tableData)
              this.pageCount = res.pageCount
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      change(row) {
        this.diaForm.userId = row.id
        this.diaForm.phone = row.userName
        this.title = this.$i18n.t('lang.btn_addWoAdmit')
        this.isPopupPage = true
        // this.$refs.diaForm.clearValidate()
      },
      del(row) {
        let loading = this.$loading()
        let params = {
          garden: this.gardenId,
          admitGuid: row.admitGuid
        }
        this.$confirm(
          this.$i18n.t('lang.lab_isdelete'),
          this.$i18n.t('lang.lab_prompt'), {
            confirmButtonText: this.$i18n.t('lang.btn_confirm'),
            cancelButtonText: this.$i18n.t('lang.btn_cancel'),
            type: 'warning'
          }
        ).then(() => {
          this.$delete(`woAdmit/` + row.waId, params).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message({
                  type: 'success',
                  message: this.$i18n.t('lang.lab_del_success')
                })
                this.pageNo = 1
                this.topics()
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        }).catch(() => {
          loading.close()
          this.$message({
            type: 'info',
            message: this.$i18n.t('lang.lab_del_can')
          })
        })
      },
      // 业主画像
      goPortrait(row) {
        console.log(row)
        this.$router.push({
          name: 'appHouseholdPortrait',
          query: {
            row: row
          }
        })
      },
      // 提交
      submit() {
        this.pageNo = 1
        this.topics()
      },
      // 通过楼层选择单元号
      selectUnit() {
        this.type = 2
        this.gardenGrids(this.floorid)
        this.unitid = ''
        this.roomid = ''
      },
      // 通过单元选择房间号
      selectRoom() {
        this.type = 3
        this.gardenGrids(this.unitid)
        this.roomid = ''
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNo = val
        this.topics()
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNo = 1
        this.pageSize = val
        this.topics()
      },
      // 调用权限（打开摄像头功能）
      getCompetence() {
        var that = this
        that.openCamera = true
        that.thisCancas = document.getElementById('canvasCamera')
        that.thisContext = this.thisCancas.getContext('2d')
        that.thisVideo = document.getElementById('videoCamera')
        that.thisVideo.style.display = 'block'
        // 获取媒体属性，旧版本浏览器可能不支持mediaDevices，我们首先设置一个空对象
        if (navigator.mediaDevices === undefined) {
          navigator.mediaDevices = {}
        }
        // 一些浏览器实现了部分mediaDevices，我们不能只分配一个对象
        // 使用getUserMedia，因为它会覆盖现有的属性。
        // 这里，如果缺少getUserMedia属性，就添加它。
        if (navigator.mediaDevices.getUserMedia === undefined) {
          navigator.mediaDevices.getUserMedia = function (constraints) {
            // 首先获取现存的getUserMedia(如果存在)
            var getUserMedia =
              navigator.webkitGetUserMedia ||
              navigator.mozGetUserMedia ||
              navigator.getUserMedia
            // 有些浏览器不支持，会返回错误信息
            // 保持接口一致
            if (!getUserMedia) {
              // 不存在则报错
              return Promise.reject(
                new Error('getUserMedia is not implemented in this browser')
              )
            }
            // 否则，使用Promise将调用包装到旧的navigator.getUserMedia
            return new Promise(function (resolve, reject) {
              getUserMedia.call(navigator, constraints, resolve, reject)
            })
          }
        }
        var constraints = {
          audio: false,
          video: {
            width: this.videoWidth,
            height: this.videoHeight,
            transform: 'scaleX(-1)',
          },
        }
        navigator.mediaDevices
          .getUserMedia(constraints)
          .then(function (stream) {
            // 旧的浏览器可能没有srcObject
            if ('srcObject' in that.thisVideo) {
              that.thisVideo.srcObject = stream
            } else {
              // 避免在新的浏览器中使用它，因为它正在被弃用。
              that.thisVideo.src = window.URL.createObjectURL(stream)
            }
            that.thisVideo.onloadedmetadata = function (e) {
              that.thisVideo.play()
            }
          })
          .catch((err) => {
            console.log(err)
            this.$message.error('摄像头连接失败')
          })
      },
      //  绘制图片（拍照功能）
      setImage() {
        var that = this
        // canvas画图
        that.thisContext.drawImage(
          that.thisVideo,
          0,
          0,
          that.videoWidth,
          that.videoHeight
        )
        // 获取图片base64链接
        var image = this.thisCancas.toDataURL('image/png')
        that.imgSrc = image // 赋值并预览图片
        // alert('拍照')
        let params = {
          fileBase64: image
        }
        that.$post('/uploadWoFace', params).then(
          res => {
            console.log(res)
            if (res && res.errCode === 0) {
              that.woFaceUrl = res.woFaceUrl
              console.log(that.woFaceUrl)
            }
          },
          error => {
            this.$message.error(error)
          }
        )
      },
      // 重拍
      resetCamera() {
        this.imgSrc = ''
      },
      // 保存图片
      saveCamera() {
        console.log(this.peopleData)
        let params = {
          garden: this.peopleData.garden.id,
          admitGuid: this.peopleData.admitGuid,
          url: this.woFaceUrl,
        }
        console.log(params)
        this.$post('/woFace', params).then(
          res => {
            console.log(res)
            if (res && res.errCode === 0) {
              this.$message.success('保存成功')
              this.peopleData = ''
              this.handleDialogClosed1()
              this.topics()
            }
          },
          error => {
            this.$message.error(error)
          }
        )
      },
      // 选择删除人像图片
      selectDelImg(e, item) {
        let obj = {
          admitGuid: item.admitGuid,
          faceGuid: item.faceGuid
        }
        if (e) {
          if (this.delPeoImgArr.length == 0) {
            this.delPeoImgArr.push(obj)
          } else {
            try {
              this.delPeoImgArr.forEach((e, index) => {
                if (e.faceGuid != obj.faceGuid) {
                  this.delPeoImgArr.push(obj)
                  throw new Error()
                }
              })
            } catch (e) {

            }
          }
        } else {
          this.delPeoImgArr.forEach((e, index) => {
            if (e.faceGuid == obj.faceGuid) {
              this.delPeoImgArr.splice(index, 1)
            }
          })
        }
        console.log(this.delPeoImgArr)
      },
      // 确定删除人像照片
      delPeoImg() {
        this.$confirm(
          this.$i18n.t('lang.lab_isdelete'),
          this.$i18n.t('lang.lab_prompt'), {
            confirmButtonText: this.$i18n.t('lang.btn_confirm'),
            cancelButtonText: this.$i18n.t('lang.btn_cancel'),
            type: 'warning'
          }
        ).then(() => {
          for (let i = 0; i < this.delPeoImgArr.length; i++) {
            let params = {
              garden: this.peopleData.garden.id,
              admitGuid: this.delPeoImgArr[i].admitGuid,
              faceGuid: this.delPeoImgArr[i].faceGuid,
            }
            this.$delete('/woFace', params).then(
              res => {
                console.log(res)
                if (res && res.errCode === 0) {
                  this.$message.success('删除成功')
                  this.peopleData = ''

                  this.handleDialogClosed2()
                  this.topics()
                } else {
                  this.$message.error(res.errMsg)
                }
              },
              error => {
                this.$message.error(error)
                this.peopleData = ''
                this.handleDialogClosed2()
                this.topics()
              }
            )
          }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$i18n.t('lang.lab_del_can')
          })
        })
      },
      // 关闭摄像头
      stopNavigator() {
        this.thisVideo.srcObject.getTracks()[0].stop()
        // alert('关闭摄像头')
      },
      // 监听关闭摄像头dialog
      handleDialogClosed1() {
        this.thisVideo.srcObject.getTracks()[0].stop()
        this.imgSrc = ''
        this.openCamera = false
        this.isShowCamera = false
      },
      // 监听关闭人像删除dialog
      handleDialogClosed2() {
        this.isShowDelImg = false
      },
      // 人像注册弹窗
      showCamera(data) {
        var that = this
        console.log(data)
        that.peopleData = data
        that.isShowCamera = true
        setTimeout(function () {
          that.getCompetence()
        }, 100)
      },
      // 人像删除弹窗
      showDelImg(data) {
        this.peopleData = data
        this.isShowDelImg = true
        this.delPeoImgArr = []
      },
      base64ToFile(base64, fileName) {
        let arr = base64.split(',')
        let mime = arr[0].match(/:(.*?);/)[1]
        let bytes = atob(arr[1])
        let n = bytes.length
        let ia = new Uint8Array(n)
        while (n--) {
          ia[n] = bytes.charCodeAt(n)
        }
        return new File([ia], fileName, {
          type: mime
        })
      },
    }
  }
</script>

<style lang='scss'>
  .woAppHouseholdManageList {
    .img-width {
      overflow: hidden !important;
      text-overflow: ellipsis !important;
      white-space: nowrap !important;
      max-width: 320px;
    }
    .img {
      width: 80px;
      height: auto;
      // border: 1px solid lightgray;
      // border-radius: 5px;
      // padding: 3px;
      margin-right:5px;
    }

    .cameraDlg {
      .el-dialog__headerbtn {
        top: 3px !important;
        right: 10px !important;
      }

      .cameraImg {
        width: 100% !important;
        height: 200px !important;
      }

      .CameraBtn {
        margin-top: 10px !important;
        text-align: center !important;
      }

      .previewTitle {
        margin-bottom: 10px !important;
        font-weight: bold !important;
        color: #00b1c3 !important;
      }

      .CameraBtn .el-button {
        padding: 12px 60px !important;
      }

      .peopleImgBox {
        display: inline-block;
        width: 30% !important;
        margin-right: 3%;
        position: relative;
      }

      .peopleImg {
        width: 100% !important;
      }

      .peoCheckBox {
        .el-checkbox__input {
          position: absolute !important;
          right: 0 !important;
        }
      }
    }
  }
</style>